import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 2,
  class: "ms-2 break-word"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tooltipMessage ? 'el-tooltip' : 'span'), _mergeProps({ class: _ctx.wrapperClass }, 
      _ctx.tooltipMessage ? { content: _ctx.tooltipMessage, placement: 'top' } : {}
    ), {
    default: _withCtx(() => [
      _createElementVNode("button", _mergeProps(_ctx.$attrs, {
        type: _ctx.type,
        disabled: _ctx.isDisabled || _ctx.isLoading || _ctx.disabled,
        class: _ctx.classComputed,
        style: _ctx.disabledStyle,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onButtonClicked && _ctx.onButtonClicked(...args)))
      }), [
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.showIcon)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: _ctx.iconComputed,
                    class: _normalizeClass(_ctx.iconClassComputed)
                  }, null, 8, ["icon", "class"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 1,
              icon: "fa fa-exclamation-triangle"
            })),
        (_ctx.hasLabelSlot)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _renderSlot(_ctx.$slots, "button-label")
            ]))
          : _createCommentVNode("", true)
      ], 16, _hoisted_1)
    ]),
    _: 3
  }, 16, ["class"]))
}